<template>
    <div class="cascaderItem">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="a_help_category_id"
                    label="分类名称"
                    prop="a_help_category_id"
                    :help="formErr.a_help_category_id"
                    :validateStatus='!formErr.a_help_category_id||formErr.a_help_category_id==""?"":"error"'
            >
<!--               -->
                <a-cascader style="width: 80%"  placeholder="请选择"  :displayRender="displayRender "  popupClassName="selectClass" :options="seleList.category" v-model="form.a_help_category_id"  :fieldNames="fieldNames"  ></a-cascader>
            </a-form-model-item>
            <a-form-model-item
                    ref="title"
                    label="标题"
                    prop="title"
                    :help="formErr.title"
                    :validateStatus='!formErr.title||formErr.title==""?"":"error"'
            >
                <a-textarea style="width: 80%"  :rows="4" v-model="form.title"  :maxLength=200
                             @change="(e) => { formErr.title=''}"
                             @blur="(e) => {  form.title = e.target.value.trim() }"/>
            </a-form-model-item>
            <a-form-model-item
                    ref="content"
                    label="内容"
                    prop="content"
                    :help="formErr.content"
                    :validateStatus='!formErr.content||formErr.content==""?"":"error"'
                    style="position: relative"
            >
                <a-input v-model="form.content"  type="hidden" />
                <div style="position: relative" ><ckeditor4  :value="contenta" ref="ckeditor" v-on:input="ckeditorContent" @instanceReadyCk="instanceReadyCk"></ckeditor4>
<!--           @changCkNum=" (type,data)=>{   cknum=type  } "           <span style=" position: absolute!important;bottom: -5px;right: 20px">{{cknum}}/10000</span>-->
</div>
            </a-form-model-item>

            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="item.value" :key="index" v-for="(item,index) in this.seleList.status"> {{item.name}} </a-radio>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item
                    ref="hot_problem"
                    label="常见问题"
                    prop="hot_problem"
                    :extra="formErr.hot_problem"
                    :validateStatus='!formErr.hot_problem||formErr.hot_problem==""?"":"error"'
            >
                <a-radio-group v-model="form.hot_problem"  >
                    <a-radio :value="item.value" :key="index" v-for="(item,index) in this.seleList.hot_problem"> {{item.name}} </a-radio>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item   >
                <a-row>
                    <a-col :span="12">
                    </a-col>
                    <a-col :span="12">
                        <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                            确定
                        </a-button>
                        <a-button  @click="onClose">
                            取消
                        </a-button>
                    </a-col>
                </a-row>
            </a-form-model-item>
        </a-form-model>

     </div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import ckeditor4 from '../../../Components/ckeditors'
    import API from "../api";
    export default {
        name: "newForm",
        props: {
            content: {
                type: String,
                default: '请输入您的内容'
            }
        },
        data() {
            return {
                cknum:0,
                id: this.$route.query.id,
                contenta: "",
                fieldNames: {label: 'name', value: 'id', children: 'children'},
                seleList:[],
                drawerConfig ,
                form: {
                    a_help_category_id:[],
                    title:"",
                    content:"",
                    hot_problem:0,
                    status:1,
                },
                formErr: {
                    a_help_category_id:"",
                    title:"",
                    content:"",
                    hot_problem:"",
                    status:"",
                },
                rules: {
                    a_help_category_id: [{required: true, message: "请选择分类",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.a_help_category_id)}  , trigger: "blur"  },],
                    title: [{required: true, message: "请输入标题 ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.title)}  , trigger: "blur"  },],
                    content:[{required: true, message: "请输入内容 " ,trigger:['change', 'blur']  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.content)}  , trigger:["blur","change"]   },],
            // {max: 10000, message: "内容不能超过10000字符 " ,trigger:['change', 'blur']  },
        },
                layout: {
                    labelCol: { span:3},
                    wrapperCol: { span:18 },
                },
            };
        },
        components:{ckeditor4},
        created() {
            this.$store.state.adminleftnavnum = "/HelpCenter/ArticleManagement"; //设置左侧导航2-2 active
        },
        mounted(){
            let _that=this
            _that.getFormData()
            this.$nextTick().then(function () { })

        },
        methods: {
            instanceReadyCk(type){
                if(type==true){
                    let _that=this
                    this.$nextTick().then(function () {
                        if(_that.id!=undefined){ _that.editform(_that.id)}
                    })
                }

            },
            displayRender(labels, selectedOptions){
                if(!labels.labels.length>0){
                    return []
                }else{
                    let arr=labels.labels
                  arr[0].length >30 ? arr[0]= arr[0].substring(0,30) +'...':""
                 if(arr[0].length >30 ) {
                     arr[1]= arr[1].substring(0,30) +'...'
                 }
                    return arr.join(' / ')
                }

            },
            ckeditorContent(val) {
                    this.form.content = val
                    console.log("****",val)
                    this.$refs.ruleForm.validateField('content', (contentError) => {
                        if(!phoneError){
                            //当校验通过时，这里面写逻辑代码
                            this.formErr.content=""
                        }
                    })
            },
    editform(id){
                API.service.EDIT_DATA(id).then(res => {
                    let data=res.data.data.info
                    let category=[]
                    let categoryJson={}
                    res.data.data.category.map((item,index)=>{
                        categoryJson={}
                        categoryJson={...item.parent}
                        categoryJson.children=item.children
                        category.push(categoryJson)
                    })
                    this.seleList={
                        category:category,
                        status:res.data.data.status,
                        hot_problem:res.data.data.hot_problem
                    }
                    // data.a_help_category_id=[]
                    let checkId=true
                    this.seleList.category.map((item,index)=>{
                        if(item.children){
                            item.children.map((items,indexs)=>{
                                if(items.id==data.a_help_category_id) {
                                    data.a_help_category_id=[items.parent_id,items.id]
                                    checkId=false
                                }
                            })
                        }else{
                            // if(item.parent.id==data.a_help_category_id)

                        }
                    })
                    if(checkId==true) data.a_help_category_id=[data.a_help_category_id , ""]
                    this.form = data
                    let _that=this
                    this.$nextTick().then(function () {
                        _that.contenta = data.content
                    })
                    // this.$nextTick(() => {
                    //     setTimeout(() => {
                    //         this.contenta = data.content
                    //     }, 800)
                    // })
                    this.form.id=id
                })
            },
            getFormData(){
                API.service.ADD_DATA().then(res => {
                    let category=[]
                    let categoryJson={}
                    res.data.data.category.map((item,index)=>{
                        categoryJson={}
                        categoryJson={...item.parent}
                        categoryJson.children=item.children
                        category.push(categoryJson)
                    })
                    this.seleList={
                        category:category,
                        status:res.data.data.status,
                        hot_problem:res.data.data.hot_problem
                    }


                })

            },
            onClose(){
                this.$router.push({path: '/HelpCenter/ArticleManagement'})
            },
            onSubmit() {
                let _this = this;
                this.$refs.ckeditor.$emit("getText")
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url


                        let subData=JSON.parse(JSON.stringify(this.form))
                        subData.content_text=subData.content
                        if(subData.a_help_category_id.length>1&&subData.a_help_category_id[1]!=""){
                            subData.a_help_category_id=subData.a_help_category_id[1]
                        }else if(subData.a_help_category_id.length=1||subData.a_help_category_id.length>1&&subData.a_help_category_id[1]==""){
                            subData.a_help_category_id=subData.a_help_category_id[0]
                        }else{
                            subData.a_help_category_id=""
                        }

                        subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, subData).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}

</style>
